<template>
  <div class="contact-box">
    <div class="m-top-box">
        <Nav/>
        <div class="m-layout-center">
            <div class="m-msg-outer">
                <div class="m-message-board">
                    <div class="m-msg-tit f18 lh30 tac mb10">
                        WE’D LOVE TO HEAR FROM YOU
                    </div>
                    <div class="m-msg-wrap" :class="{'m-msg-wrap2':!resetJson.verify}">
                        <div class="m-msg-shadow"></div>
                        <div class="m-msg-box">
                            <ul class="m-msg-main" ref="jList">
                                <li class="">
                                    <span class="fl f14">姓名</span>
                                    <input class="fl" type="text" name="clientname" id="clientname" txt = '姓名'>
                                    <p class="" id="clientname_error"></p>
                                </li>
                                <li class="">
                                    <span class="fl f14">邮箱</span>
                                    <input class="fl" type="text" name="email" id="email" txt = '邮箱'>
                                    <p class="" id="email_error"></p>
                                </li>
                                <li class="">
                                    <span class="fl f14">手机</span>
                                    <input class="fl" type="text" name="phone" id="phone" txt = '手机'>
                                    <p class="" id="phone_error"></p>
                                </li>
                                <li class="" v-if="!resetJson.verify">
                                    <span class="fl f14">验证码</span>
                                    <input class="fl vercode" type="text" name="vercode" id="vercode" txt="验证码">
                                    <img :src="resetJson.resetFile" class="verimg" @click="resetKaptcha">
                                    <p class="" id="vercode_error"></p>
                                </li>
                                <li class="mb10">
                                    <span class="fl f14">留言</span>
                                    <textarea class="fl" name="message" id="message" txt='留言'>
                                    </textarea>
                                    <p class="" id="message_error"></p>
                                </li>
                                <li class="tac">
                                    <input type="button" value="提交" class="m-submi-btn tac f14" @click="submitBn">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
	<div class="m-layout-center">
		<div class="pt40">
            <div class="tac mb50 m-main-tit">
				<h3 class="s-main-color1">云码通-贵阳</h3>
				<div class="u-line"></div>
			</div>
            <ul class="m-contact-list">
                <li class="fl tac mb40">
                    <img src="../assets/images/lxwm_01@2x.png" alt="" width="60" height="80">
                    <p class="u-recruit-txt1 u-recruit-txt-1 f18 lh26">地址</p>                  
                    <p class="f14 lh26 s-gray-color2">
						贵阳国家高新技术产业开发区<br/>
						毕节路58号联合广场2号楼26、27层
                    </p>
                </li>
				<li class="fl tac mb40">
                    <img src="../assets/images/lxwm_02@2x.png" alt="" width="80" height="80">
                    <p class="u-recruit-txt1 u-recruit-txt-2 f18 lh26">联系方式</p>                  
                    <p class="f14 lh26 s-gray-color2">
						0851-83660455
                    </p>
                </li>
				<li class="fl tac mb40">
                    <img src="../assets/images/lxwm_03@2x.png" alt="" width="84" height="82">
                    <p class="u-recruit-txt1 u-recruit-txt-3 f18 lh26">邮箱</p>                  
                    <p class="f14 lh26 s-gray-color2">
						YMT_GUIYANG@ymt.net
                    </p>
                </li>
            </ul>
		</div>
	</div>
    <div class="m-location-box"></div>
    <Dialog :params="this.dialog" @listenDialog="dialogClose" v-show="this.dialog.isShow">
        <div class="tmpl">
        <div class="ta-center">
            <p class="submitmsg s-gray-color2">提交成功</p>
            <a href="javascript:;" class="confirm tac" @click="submitAlert">确定</a>
        </div>
        </div>
    </Dialog>
  </div>
</template>
<style scoped lang="scss">
    .m-msg-outer{
        width: 1100px;
        height: 590px;
        // padding-top: 100px;
        overflow: hidden;
        position: relative;
    }
    .m-message-board{
        width: 380px;
        height: 480px;
        .m-msg-tit{
            font-family: 'PingFangSC-Medium';
            color: #fff;
        }
        position: absolute;
        bottom: 40px;
        right: 45px;
        .m-msg-wrap{
            width: 380px;
            height: 440px;
            position: relative;
        }
        .m-msg-shadow{
            background-color: #293049;
            opacity: 0.3;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
        }
        .m-msg-box{
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
        }
        .m-msg-main{
            li{
                overflow: hidden;
            }
            padding: 40px 26px;
            span{
                display: inline-block;
                width: 48px;
                height: 30px;
                line-height: 30px;
                color: #fff;
            }
            input[type="text"]{
                display: inline-block;
                width:270px;
                height: 30px;
                padding-left: 10px;
                border: 0;
                font-size: 16px;
            }
            textarea{
                width: 260px;
                padding: 10px;
                height: 76px;
                border: 0;
                resize: none;
                font-size: 16px;
            }
            .m-submi-btn{
                display: inline-block;
                width: 100px;
                height: 30px;
                line-height: 30px;
                background-color: #00B9FF;
                border-radius: 4px;
                border: 0;
                color: #fff;
                text-align:center;
                // margin-left: 104px;
                cursor: pointer;
            }
            p
            {
                display: inline-block;
                margin-left: 50px;
                color: #ff6600;
                font-size: 12px;
                line-height: 18px;
                // height: 18px;
            }
            input.vercode
            {
                width: 130px;
            }
            .verimg
            {
                width: 130px;
                height: 30px;
                margin-left: 10px;
                cursor: pointer;
            }
        }
    }
	.m-top-box{ 
		width: 100%; 
		padding-top: 10px;
        height: 590px; 
		background: url(https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/lxwm_banner1@1x.jpg) no-repeat center top;
		background-size:cover; 
		h2 {
			color: #fff;
			font-size: 68px;
			font-weight: 500;
			text-align: center;
			height: 100px;
			line-height: 100px;
			margin-top: 166px;
			margin-bottom: 5px;
        }
        .m-slogan-txt{
            height: 38px;
            line-height: 38px;
            color: #fff;
        }
    }

    .m-contact-list{
        overflow: hidden;
        li{
			width: 294px;
			padding: 0 36px;
        }
        .u-recruit-txt-1{
            margin-top: 18px;
            margin-bottom: 6px;
        }
        .u-recruit-txt-2{
            margin-top: 21px;
            margin-bottom: 6px;
        }
        .u-recruit-txt-3{
            margin-top: 26px;
            margin-bottom: 6px;
        }
       
    }
    .m-location-box{
        width: 100%; 
		height: 724px; 
		background: url(https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/lxwm_location@1x.jpg) no-repeat center top;
		background-size:cover; 
    }
    .submitmsg
    {
        font-size: 14px;
        
    }
    .tmpl
    {
        .confirm
        {
            font-size: 14px;
            background:#00B9FF;
            width: 100px;
            height: 30px;
            line-height: 30px;
            border-radius: 4px;
            color: #fff;
            display: inline-block;
            margin-top: 20px;   
        }
    }
 </style>
<script>
import Nav from '@/components/Nav.vue'
import Dialog from '@/components/dialog/index.vue'
export default {
  name:'contact',
  data() {
      return{
          arr:[
            {
                name:"clientname",
                reg:'',
                txt:''
            },
            {
                name:"email",
                reg:/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                txt:''
            },
            {
                name:"phone",
                reg: /^1\d{10}$/,
                txt:''
            },
            {
                name:"message",
                reg:'',
                txt:''
            }
        ],
        dialog: {
            title:'',
            desc:'',
            btnTxt:'',
            btnLink:'',
            isShow: false
        },
        token:'',
        resetJson:{
            resetFile:'',
            verify:''
        }
      }
  },
  components: {
    Nav,
    Dialog
  },
  created(){
      return this.getToken().then(()=>{
           this.resetKaptcha();
      })
  },
  methods:{
        dialogClose()
        {
            this.dialog = {
                title:'',
                desc:'',
                btnTxt:'',
                btnLink:'',
                isShow: false
            }
        },
        inputVerify(obj,inputReg,tipTxt)
        {
            var inputObj = document.getElementById(obj);
            var inputName = inputObj.getAttribute('txt');
            var tipObj = document.getElementById(obj+'_error');
            if(inputObj.value == '')
            {
                tipObj.innerHTML = inputName+'不能为空';
                tipObj.className = 'error';
                return false;
            } 
            else if(inputReg)
            {
                if(!inputReg.test(inputObj.value))
                {
                    tipObj.innerHTML = inputName+'格式不正确';
                    tipObj.className = 'error';
                    return false;
                }
                else
                {
                    tipObj.innerHTML = '';
                    tipObj.className = '';
                }
            }
            else if(tipTxt)
            {
                tipObj.innerHTML = tipTxt;
                tipObj.className = 'error';
                return false;
            }
            else
            {
                tipObj.innerHTML = '';
                tipObj.className = '';
            }
        },
        getToken()
        {
            // console.log(window.API_HOST_S);
            var p = new Promise((resolve,reject)=>{
                let tokenData = this.$qs.stringify({
                    platformId:1
                })
                this.axios({
                    method:'post',
                    url:window.API_HOST+'/api/token',
                    data:tokenData
                }).then((res2)=>{
                    var res = res2.data;
                    if(res.message.code == 0)
                    {
                        this.token = res.data.token; 
                        resolve(this.token);
                    }
                    else
                    {
                        reject(console.log(res));
                    }
                })
            });
            return p;
        },
        resetKaptcha()
        {
            this.resetJson.resetFile = window.API_HOST+'/activity/kaptcha?type=2&token='+this.token+'&timeStamp='+new Date().getTime();
        },
      submitBn()
      {
          var arr2 = ['clientname_error','email_error','phone_error','message_error'];
          if(!this.resetJson.verify)
          {
              this.arr.push({
                    name:'vercode',
                    reg:'',
                    txt:''
              })
          }
          if(!this.resetJson.verify)
          {
              arr2.push('vercode_error');
          }
        //   console.log(arr2)
          for(let i=0;i<this.arr.length;i++)
          {
              this.inputVerify(this.arr[i].name,this.arr[i].reg,this.arr[i].txt);
          }
            
            let paramsData = {
                name:document.getElementById('clientname').value,
                email:document.getElementById('email').value,
                mobile:document.getElementById('phone').value,
                message:document.getElementById('message').value,
            }
            if(this.resetJson.verify)
            {
                paramsData.verify = this.resetJson.verify;
            }
            else
            {
                paramsData.verify_code = document.getElementById('vercode').value;
                paramsData.token = this.token;
            }
            let postData = this.$qs.stringify(paramsData);
            for(let i=0;i<arr2.length;i++)
            {
                if(document.getElementById(arr2[i]).className == 'error')
                {
                    return false;
                } 
            }
            this.axios({
                method: 'post',
                url: window.API_HOST_S+'/api/messageCommit',
                data: postData
            }).then((res1)=>{
                var res = res1.data;
                if(res.message.code == 0)
                {
                    this.dialog.isShow = true;
                }
                else
                {
                    this.dialog.isShow = true;
                    this.dialog.desc = res.message.message;
                    this.dialog.btnLink = "javascript:;";
                    this.dialog.btnTxt = '确定'
                    // this.inputVerify('message','',res.message.message);
                }
            })
            
      },
      submitAlert()
      {
          window.location.reload();
      }
  }
}
</script>